var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var InfoProvider =
/** @class */
function () {
  function InfoProvider() {
    this.samples = [];
    this.scalars = new Set();
    this.elements = new Set();
    this.runs = new Set();
    this.analyses = new Set();
    this.scalarsRange = {};
    this.elementsRange = {};
  }

  InfoProvider.prototype.setData = function (samples) {
    var _this = this;

    this.samples = [];
    this.elements = new Set();
    this.scalars = new Set();
    this.runs = new Set();
    this.analyses = new Set();
    this.elementsRange = {};
    this.scalarsRange = {};

    if (samples.length === 0) {
      return;
    }

    var compositions = {};
    var scalars = {};

    for (var _i = 0, samples_1 = samples; _i < samples_1.length; _i++) {
      var sample = samples_1[_i];
      Object.entries(sample.composition).forEach(function (_a) {
        var element = _a[0],
            fraction = _a[1];

        if (!(element in compositions)) {
          compositions[element] = [fraction, fraction];
        }

        if (fraction < compositions[element][0]) {
          compositions[element][0] = fraction;
        } else if (fraction > compositions[element][1]) {
          compositions[element][1] = fraction;
        }
      });
      sample.fom.forEach(function (fom) {
        var name = fom.name,
            value = fom.value,
            runId = fom.runId,
            analysisId = fom.analysisId;

        if (!(name in scalars)) {
          scalars[name] = [value, value];
        }

        if (value < scalars[name][0]) {
          scalars[name][0] = value;
        } else if (value > scalars[name][1]) {
          scalars[name][1] = value;
        }

        _this.scalars.add(name);

        _this.runs.add(runId);

        _this.analyses.add(analysisId);
      });
    }

    this.scalarsRange = __assign({}, scalars);
    var elements = Object.keys(compositions);

    for (var _a = 0, elements_1 = elements; _a < elements_1.length; _a++) {
      var element = elements_1[_a];
      var range = compositions[element];

      if (range[1] > Number.EPSILON) {
        this.elements.add(element);
        this.elementsRange[element] = range;
      }
    }

    this.samples = samples;
  };

  InfoProvider.prototype.getScalarsRange = function () {
    return this.scalarsRange;
  };

  InfoProvider.prototype.getScalarRange = function (key) {
    if (key in this.scalarsRange) {
      return this.scalarsRange[key];
    }

    return [0, 0];
  };

  InfoProvider.prototype.getScalars = function () {
    var scalars = [];
    this.scalars.forEach(function (val) {
      scalars.push(val);
    });
    return scalars;
  };

  InfoProvider.prototype.getElements = function () {
    var elements = [];
    this.elements.forEach(function (val) {
      elements.push(val);
    });
    return elements;
  };

  InfoProvider.prototype.getValidScalar = function (key) {
    if (key === void 0) {
      key = null;
    }

    if (this.scalars.has(key)) {
      return key;
    } else {
      try {
        return this.scalars.values().next().value;
      } catch (e) {
        return null;
      }
    }
  };

  InfoProvider.prototype.getSamples = function () {
    return this.samples;
  };

  InfoProvider.getSampleScalar = function (sample, scalar, runId, analysisId) {
    var matchRunId = !!runId;
    var matchAnalysisId = !!analysisId;

    for (var _i = 0, _a = sample.fom; _i < _a.length; _i++) {
      var fom = _a[_i];
      var isMatch = fom.name === scalar && (runId == fom.runId || !matchRunId) && (analysisId == fom.analysisId || !matchAnalysisId);

      if (isMatch) {
        return fom.value;
      }
    }

    return null;
  };

  return InfoProvider;
}();

export { InfoProvider };